export const CASH_REGISTER_READING_STATUS_DRAFT = "DRAFT";
export const CASH_REGISTER_READING_STATUS_CANCELED = "CANCELED";
export const CASH_REGISTER_READING_STATUS_VALIDATED = "VALIDATED";

export const cashRegisterReadingStatusesOption = [
  CASH_REGISTER_READING_STATUS_DRAFT,
  CASH_REGISTER_READING_STATUS_CANCELED,
  CASH_REGISTER_READING_STATUS_VALIDATED,
];
